<template>
  <div class="entry-area my-5">
    <h3 class="form-ttl">
      {{ $t('register-page.step-three.title-1', { split: '/' }) }}
    </h3>
    <h3 class="form-ttl">
      {{ $t('register-page.step-three.title-2', { split: '/' }) }}
    </h3>
    <div class="my-5">
      <table class="table-custom-detail" border="1" cellspacing="0" cellpadding>
        <tbody>
          <tr class="tr-response" v-if="isShowBasicInformationField('img')">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.avatar', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right img-fix-height">
                <img :src="img" alt="" class="img-preview" />
              </div>
            </td>
          </tr>

          <tr class="tr-response" v-if="isShowBasicInformationField('name')">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.name', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ name }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="
              isShowBasicInformationField('name_kana') &&
              this.$i18n.locale === LANG_CODE_JAPANESE
            "
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.name_kana', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ name_kana }}
              </div>
            </td>
          </tr>

          <tr class="tr-response" v-if="isShowBasicInformationField('gender')">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.gender', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ $t(genderFormat, { split: '' }) }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowBasicInformationField('birthday')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.birthday', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ formatDate(birthday) }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowBasicInformationField('mail_address')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.mail-address', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ mail_address }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowBasicInformationField('re_mail_address')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.re-mail-address', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ re_mail_address }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowBasicInformationField('phone_number')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.phone-number', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ phone_number }}
              </div>
            </td>
          </tr>
          <tr class="tr-response" v-if="isShowBasicInformationField('address')">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.address1', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">{{ areaFormat }}</div>
            </td>
          </tr>
          <tr class="tr-response" v-if="isShowBasicInformationField('address')">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.address2', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">{{ address }}</div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowBasicInformationField('hometown_id')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.hometown', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">{{ homeTownFormat }}</div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowBasicInformationField('facebook')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.facebook', {
                      split: '/'
                    })
                  }}
                </div>
                <div class="col-require text-right"></div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ facebook }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowBasicInformationField('timezone')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-one.timezone', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ timezoneFormat }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('last_academic_history')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.last-academic-history', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right pre-line">
                {{ last_academic_history }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('study_status')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.study-status', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ studyStatusFormat }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('university_id')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.university', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ universityIdFormat }}
              </div>
              <div class="div-right" v-if="university_input_text_flag == 1">
                {{ school_name }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="
              university_id == OTHER_SELECT &&
              isShowEntryInformationField('school_name')
            "
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.school-name', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ school_name }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('faculty_id')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.faculty_id', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">{{ facultyIdFormat }}</div>
              <div class="div-right" v-if="faculty_input_text_flag == 1">
                {{ faculty }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="
              faculty_id == OTHER_SELECT &&
              isShowEntryInformationField('faculty')
            "
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.faculty', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">{{ faculty }}</div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('graduation_month')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.graduation-month', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ formatMonth(graduation_month) }}
              </div>
            </td>
          </tr>

          <tr class="tr-response">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.work-status', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td
              class="td-right"
              v-if="isShowEntryInformationField('work_status')"
            >
              <div class="div-right">
                {{ workStatusFormat }}
              </div>
            </td>
            <td
              class="td-right"
              v-if="isShowEntryInformationField('work_status_text')"
            >
              <div class="div-right pre-line">
                {{ work_status_text }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="
              isShowEntryInformationField('company_name') && checkWorkStatus
            "
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.company-name', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">{{ company_name }}</div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="
              isShowEntryInformationField('industry_type') && checkWorkStatus
            "
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.industry-type', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ industryTypeFormat() }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="
              isShowEntryInformationField('occupation_type') && checkWorkStatus
            "
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.position', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ occupationTypeFormat }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="
              isShowEntryInformationField('work_contract_type') &&
              checkWorkStatus
            "
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.work-contract-type', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ workContractFormat }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="
              checkRetireWorkStatus &&
              checkWorkStatus &&
              isShowEntryInformationField('resignation_month')
            "
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.resignation-month', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ formatDate(resignation_month) }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('jlpt_level')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.japanese-level', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ japanLevelFormat }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('english_level')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.english-level', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ englishLevelFormat }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('toeic_score')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.toeic', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ toeic_score }}
              </div>
            </td>
          </tr>

          <tr class="tr-response">
            <td class="td-left">
              <div class="div-left">
                <div
                  class="col-title"
                  v-if="isShowEntryInformationField('skill_type')"
                >
                  {{
                    $t('register-page.step-two.skills', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  class="col-title"
                  v-if="isShowEntryInformationField('skill_name_text')"
                >
                  {{
                    $t('register-page.step-two.skill-text', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td
              class="td-right"
              v-if="isShowEntryInformationField('skill_type')"
            >
              <div class="div-right">
                <div
                  class="widget-skill"
                  v-for="(item, index) in skillTypeFormat"
                  :key="index"
                >
                  {{ item.name_convert }} <br />
                </div>
              </div>
            </td>
            <td
              class="td-right"
              v-if="isShowEntryInformationField('skill_name_text')"
            >
              <div class="div-right pre-line">
                {{ skill_name_text }}
              </div>
            </td>
          </tr>

          <tr class="tr-response">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.occupation-type', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>

            <td
              class="td-right"
              v-if="isShowEntryInformationField('expect_occupation_type')"
            >
              <div class="div-right">
                <div
                  class="widget-skill"
                  v-for="(item, index) in expectOccupationTypeFormat()"
                  :key="index"
                >
                  {{ item.name_convert }} <br />
                </div>
              </div>
            </td>
            <td
              class="td-right"
              v-if="isShowEntryInformationField('expect_occupation_type_text')"
            >
              <div class="div-right pre-line">
                {{ expect_occupation_type_text }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('expected_requirements')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.expected-requirements', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right pre-line">
                {{ expected_requirements }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('expected_pay')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.expected-pay', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right pre-line">
                {{ expected_pay }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('any_additional_comments')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.any-additional-comments', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right pre-line">
                {{ any_additional_comments }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('work_location')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.work-location', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ workLocationFormat }}
              </div>
            </td>
          </tr>

          <tr class="tr-response">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.self_promotion', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                {{ self_promotion }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4 class="form-ttl">
      {{
        $t('register-page.step-three.info-login-title', {
          split: '/'
        })
      }}
    </h4>

    <div class="form-ttl mt-2">
      {{
        $t('register-page.step-three.info-login-description-1', {
          split: '/'
        })
      }}
    </div>

    <div class="form-ttl">
      {{
        $t('register-page.step-three.info-login-description-2', {
          split: '/'
        })
      }}
    </div>

    <div class="my-5">
      <table class="table-custom-detail" border="1" cellspacing="0" cellpadding>
        <tbody>
          <tr class="tr-response">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-three.password', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <input
                    name="password"
                    placeholder=""
                    maxlength="30"
                    class="input-custom"
                    v-bind:class="{
                      'error-validate':
                        $v.password.$invalid && $v.password.$dirty
                    }"
                    v-model.trim="$v.password.$model"
                    ref="password"
                    type="password"
                  />
                  <span
                    class="form-error-tip"
                    v-if="
                      $v.password.$invalid &&
                      $v.password.$dirty &&
                      !$v.password.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <span
                    class="form-error-tip"
                    v-if="
                      $v.password.$invalid &&
                      $v.password.$dirty &&
                      !$v.password.minLength
                    "
                    >{{
                      $t('validate.password-length', {
                        split: '/'
                      })
                    }}</span
                  >
                  <span
                    class="form-error-tip"
                    v-if="
                      $v.password.$invalid &&
                      $v.password.$dirty &&
                      !$v.password.maxLength
                    "
                    >{{
                      $t('validate.password-maxLength', {
                        split: '/'
                      })
                    }}</span
                  >
                </div>
              </div>
            </td>
          </tr>

          <tr class="tr-response">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-three.re-password', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <input
                    type="password"
                    name="rePassword"
                    maxlength="30"
                    placeholder=""
                    class="input-custom"
                    v-bind:class="{
                      'error-validate':
                        $v.rePassword.$invalid && $v.rePassword.$dirty
                    }"
                    v-model.trim="$v.rePassword.$model"
                    ref="rePassword"
                  />
                  <span
                    class="form-error-tip"
                    v-if="
                      $v.rePassword.$invalid &&
                      $v.rePassword.$dirty &&
                      !$v.rePassword.sameAs
                    "
                    >{{
                      $t('validate.password-not-match', {
                        split: '/'
                      })
                    }}</span
                  >
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4 class="form-ttl">
      {{
        $t('register-page.step-three.info-confirm', {
          split: '/'
        })
      }}
    </h4>

    <div class="my-5">
      <table class="table-agree" cellspacing="0" cellpadding>
        <tbody>
          <tr>
            <td>
              <div
                class="text-area-box"
                v-html="
                  m_privacy_policy !== null || m_privacy_policy !== ''
                    ? m_privacy_policy
                    : ''
                "
              ></div>
            </td>
          </tr>

          <tr>
            <td class="title-agree my-2">
              <input
                type="checkbox"
                v-model="agree"
                name="agree"
                class="mr-2"
              />

              {{ $t('register-page.agree', { split: '/' }) }}
            </td>
          </tr>
          <tr>
            <td class="title-agree">
              <span v-if="agree === false" class="agree-error mt-2">
                {{
                  $t('register-page.step-three.agree-error', {
                    split: '/'
                  })
                }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bottom-btn my-5 text-center">
      <button class="btn-next-outline mr-2" v-on:click="goBack">
        {{ $t('register-page.btn.btn-back', { split: '/' }) }}
      </button>
      <button class="btn-next ml-2" @click="handleShowDetail">
        {{ $t('register-page.btn.btn-register', { split: '/' }) }}
      </button>
    </div>

    <v-dialog v-model="dialog" max-width="520">
      <v-card class="dialog-container">
        <v-icon color="#E8320D" class="close-icon" @click="handleCloseDialog"
          >{{ closeIcon }}
        </v-icon>
        <div class="dialog">
          <h4 v-html="$t('register-page.popup.notify', { split: '/' })"></h4>
          <v-card-actions>
            <v-btn
              class="btn-ok"
              depressed
              color="#e8320e"
              @click="submit"
              :loading="btnLoading"
            >
              {{ $t('header.btn-ok', { split: '/' }) }}
            </v-btn>

            <v-btn @click="handleCloseDialog" outlined color="#e8320e">
              {{ $t('header.btn-cancer', { split: '/' }) }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiClose } from '@mdi/js';
// import { mapGetters } from "vuex";
import {
  required,
  minLength,
  sameAs,
  maxLength
} from 'vuelidate/lib/validators';
import {
  MALE,
  FEMALE,
  LANG_CODE_JAPANESE,
  OTHER_SELECT_TEXT_JP,
  OTHER_SELECT_TEXT_VN,
  WORK_STATUS_YES
} from '@/common/constants';

export default {
  name: 'StepOne',
  props: ['urlRegisterCode'],
  data() {
    return {
      status: '',
      checked: true,

      closeIcon: mdiClose,

      password: '',
      rePassword: '',

      name: '',
      name_kana: '',
      gender: 1,
      birthday: '',
      mail_address: '',
      re_mail_address: '',
      phone_number: '',
      address: '',
      area_id: '',
      hometown_id: '',
      facebook: '',
      time_zone: '',

      study_status: '',
      university_id: '',
      university_input_text_flag: '',
      school_name: '',
      faculty_id: '',
      faculty_input_text_flag: '',
      faculty: '',
      graduation_month: new Date().toISOString().substr(0, 10),
      work_status: '',
      checkWorkStatus: false,
      company_name: '',
      self_promotion: '',
      industry_type: '',
      occupation_type: [],
      job_type: '',
      work_contract_type: '',
      resignation_month: new Date().toISOString().substr(0, 10),
      jlpt_level: '',
      english_level: '',
      toeic_score: '',
      skill_type: [],
      expect_occupation_type: '',
      work_location: '',

      skillArray: {},

      skills: {},

      last_academic_history: '',
      work_status_text: '',
      skill_name_text: '',
      expect_occupation_type_text: '',
      expected_requirements: '',
      expected_pay: '',
      any_additional_comments: '',

      dialog: false,
      btnLoading: false,
      agree: null,
      checkRetireWorkStatus: false
    };
  },

  validations: {
    password: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(30)
    },
    rePassword: {
      required,
      sameAs: sameAs('password'),
      maxLength: maxLength(30)
    }
  },

  methods: {
    checkSizeObject(obj = {}) {
      let size = 0;

      Object.keys(obj).map(() => {
        size++;
      });
      return size;
    },

    goBack() {
      this.$router.replace({
        name: 'register-applicant',
        query: { event_day_register_url_code: this.urlRegisterCode, step: 2 }
      });
    },

    handleShowDetail() {
      this.validateForm();

      if (this.agree === null) {
        this.agree = false;
      }

      if (!this.$v.$error && this.agree === true) {
        this.dialog = true;
      }
    },
    handleCloseDialog() {
      this.dialog = false;
    },

    async submit() {
      this.validateForm();

      this.btnLoading = true;

      if (!this.$v.$error) {
        const registerData =
          localStorage.getItem('registerData') !== null
            ? localStorage.getItem('registerData')
            : null;

        if (registerData !== null) {
          const { stepOne, stepTwo } = JSON.parse(registerData);

          const data = {
            ...stepOne,
            ...stepTwo,
            password: this.password
          };

          if (this.urlRegisterCode !== null) {
            data.event_day_register_url_code = this.urlRegisterCode;
          }

          this.$store.dispatch('register', { data });
        }
      }
    },

    inputCheck(name) {
      if (this.$v[name].$invalid && this.$v[name].$dirty) {
        this.$refs[name].focus();
      }
    },

    /**
     * Kiểm tra dữ liệu đầu vào
     */
    validateForm() {
      this.$v.$touch();

      // check thông tin input
      this.inputCheck('rePassword');
      this.inputCheck('password');
    },

    industryTypeFormat: function () {
      const arr = this.m_industry_type.filter(
        (ele) => ele.id === this.industry_type
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    expectOccupationTypeFormat: function () {
      const arr = this.m_occupation_type_no_group.filter((ele) => {
        if (this.expect_occupation_type.includes(ele.id)) {
          return true;
        }
      });

      return arr;
    }
  },

  watch: {
    registerStatus: function (val) {
      if (val === true && this.registerResult !== null) {
        localStorage.removeItem('registerData');

        this.btnLoading = false;
        this.dialog = false;
        this.$store.dispatch('resetRegisterStatus');

        this.$router.replace({
          name: 'register-applicant',
          query: { event_day_register_url_code: this.urlRegisterCode, step: 4 }
        });
      } else {
        this.$store.dispatch('resetRegisterStatus');
        this.btnLoading = false;
        this.dialog = false;
      }
    },

    work_status: function (val) {
      this.work_status = val;

      if (val == WORK_STATUS_YES) {
        this.checkWorkStatus = true;
        this.checkRetireWorkStatus = true;
      } else {
        this.checkRetireWorkStatus = false;
      }
    }
  },

  beforeMount() {
    const registerData =
      localStorage.getItem('registerData') !== null
        ? localStorage.getItem('registerData')
        : null;
    if (registerData !== null) {
      const { stepOne, stepTwo } = JSON.parse(registerData);
      if (
        typeof stepOne.name !== 'undefined' &&
        stepTwo &&
        typeof stepTwo.study_status !== 'undefined'
      ) {
        const {
          img,
          name,
          name_kana,
          gender,
          birthday,
          mail_address,
          re_mail_address,
          phone_number,
          address,
          area_id,
          hometown_id,
          facebook,
          time_zone
        } = stepOne;

        const {
          study_status,
          university_id,
          university_input_text_flag,
          school_name,
          faculty_id,
          faculty_input_text_flag,
          faculty,
          graduation_month,
          work_status,
          company_name,
          self_promotion,
          industry_type,
          occupation_type,
          job_type,
          work_contract_type,
          resignation_month,
          jlpt_level,
          english_level,
          toeic_score,
          expect_occupation_type,
          work_location,
          skillArray,
          skill_type,
          last_academic_history,
          work_status_text,
          skill_name_text,
          expect_occupation_type_text,
          expected_requirements,
          expected_pay,
          any_additional_comments
        } = stepTwo;
        return [
          (this.img = img), // step-1
          (this.name = name),
          (this.name_kana = name_kana),
          (this.gender = gender),
          (this.birthday = birthday),
          (this.mail_address = mail_address),
          (this.re_mail_address = re_mail_address),
          (this.phone_number = phone_number),
          (this.address = address),
          (this.area_id = area_id),
          (this.hometown_id = hometown_id),
          (this.facebook = facebook),
          (this.time_zone = time_zone),
          (this.study_status = study_status),
          (this.university_id = university_id),
          (this.school_name = school_name),
          (this.university_input_text_flag = university_input_text_flag),
          (this.faculty_id = faculty_id),
          (this.faculty_input_text_flag = faculty_input_text_flag),
          (this.faculty = faculty),
          (this.graduation_month = graduation_month),
          (this.work_status = work_status), // step-2
          (this.company_name = company_name),
          (this.self_promotion = self_promotion),
          (this.industry_type = industry_type),
          (this.occupation_type = occupation_type),
          (this.job_type = job_type),
          (this.work_contract_type = work_contract_type),
          (this.resignation_month = resignation_month),
          (this.jlpt_level = jlpt_level),
          (this.english_level = english_level),
          (this.toeic_score = toeic_score),
          (this.expect_occupation_type = expect_occupation_type),
          (this.work_location = work_location),
          (this.skillArray = skillArray),
          (this.skill_type = skill_type),
          (this.last_academic_history = last_academic_history),
          (this.work_status_text = work_status_text),
          (this.skill_name_text = skill_name_text),
          (this.expect_occupation_type_text = expect_occupation_type_text),
          (this.expected_requirements = expected_requirements),
          (this.expected_pay = expected_pay),
          (this.any_additional_comments = any_additional_comments)
        ];
      }
    }
  },

  computed: {
    genderFormat: function () {
      if (this.gender === MALE) {
        return 'register-page.btn-gender.male';
      } else if (this.gender === FEMALE) {
        return 'register-page.btn-gender.female';
      }
      return 'register-page.btn-gender.other';
    },

    timezoneFormat: function () {
      const arr = this.c_time_zone.filter((ele) => ele.id === this.time_zone);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    studyStatusFormat: function () {
      const arr = this.c_study_status.filter(
        (ele) => ele.id === this.study_status
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    workStatusFormat: function () {
      const arr = this.c_work_status.filter(
        (ele) => ele.id === this.work_status
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    universityIdFormat: function () {
      if (this.university_id == '0' || this.university_id === null) {
        return this.$i18n.locale == LANG_CODE_JAPANESE
          ? OTHER_SELECT_TEXT_JP
          : OTHER_SELECT_TEXT_VN;
      } else {
        const arr = this.m_university.filter(
          (ele) => ele.id === this.university_id
        );
        if (arr.length > 0) {
          return arr[0].name_convert;
        } else return null;
      }
    },

    facultyIdFormat: function () {
      if (this.faculty_id == '0' || this.faculty_id == null) {
        return this.$i18n.locale == LANG_CODE_JAPANESE
          ? 'その他 / Other'
          : 'Khác';
      } else {
        const arr = this.m_faculty.filter((ele) => ele.id === this.faculty_id);
        if (arr.length > 0) {
          return arr[0].name_convert;
        } else return null;
      }
    },

    workContractFormat: function () {
      const arr = this.c_work_contract_type.filter(
        (ele) => ele.id === this.work_contract_type
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    japanLevelFormat: function () {
      const arr = this.c_japanese_level.filter(
        (ele) => ele.id === this.jlpt_level
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    englishLevelFormat: function () {
      const arr = this.c_english_level.filter(
        (ele) => ele.id === this.english_level
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    workLocationFormat: function () {
      const arr = this.m_work_location_applicant.filter(
        (ele) => ele.id === this.work_location
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    areaFormat: function () {
      const arr = this.m_area.filter((ele) => ele.id === this.area_id);
      if (arr.length > 0) {
        return arr[0].area_name;
      } else return null;
    },

    skillTypeFormat: function () {
      const arr = this.m_skill.filter((ele) => {
        if (this.skill_type.includes(ele.id)) {
          return true;
        }
      });

      return arr;
    },

    occupationTypeFormat: function () {
      const arr = this.m_occupation_type_no_group.filter(
        (ele) => ele.id === this.occupation_type[0]
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    homeTownFormat: function () {
      const arr = this.m_hometown.filter((ele) => ele.id === this.hometown_id);
      if (arr.length > 0) {
        return arr[0].hometown_name;
      } else return null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/devices.scss';

.table-custom-detail {
  td {
    word-break: break-word;

    .pre-line {
      white-space: pre-line;
    }
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .table-custom-detail .td-left {
    width: 45% !important;
  }
}

@include tablet {
  .btn-ok {
    margin-bottom: 18px !important;
  }
}

@include mobile {
  .btn-ok {
    margin-bottom: 18px !important;
  }
}

.pre-formatted {
  white-space: pre-wrap;
  border: 1px dotted;
  padding: 1rem;
}
</style>
